import {
  accountsTableColumns,
  contactTableColumns,
} from 'src/features/multiDbExternal/utils/tableColumns';

/* Actions */
export const SET_MDQS_ACCOUNT_COLUMNS = 'SET_MDQS_ACCOUNT_COLUMNS';
export const setMdqsAccountsColumns = (columns: MdqsColumn[]) => ({
  type: SET_MDQS_ACCOUNT_COLUMNS,
  payload: columns,
});

export const SET_MDQS_CONTACT_COLUMNS = 'SET_MDQS_CONTACT_COLUMNS';
export const setMdqsContactsColumns = (columns: MdqsColumn[]) => ({
  type: SET_MDQS_CONTACT_COLUMNS,
  payload: columns,
});

/* Initial States */
const initialAccountsState: MdqsColumn[] = accountsTableColumns.filter(
  (item: any) => item.preferred,
);
const initialContactsState: MdqsColumn[] = contactTableColumns.filter(
  (item: any) => item.preferred,
);

interface Action {
  type: string;
  payload: MdqsColumn[];
}

interface MdqsColumn {
  column_id: string;
  title: string;
  field: string;
  checked: boolean;
  disabled?: boolean;
  width?: number | string;
  height?: number | string;
}

/* Reducers */
export const mdqsAccountsColumnsReducer = (state = initialAccountsState, action: Action) => {
  switch (action.type) {
    case SET_MDQS_ACCOUNT_COLUMNS:
      return [...action.payload];

    default:
      return state;
  }
};

export const mdqsContactsColumnsReducer = (state = initialContactsState, action: Action) => {
  switch (action.type) {
    case SET_MDQS_CONTACT_COLUMNS:
      return [...action.payload];

    default:
      return state;
  }
};
